<template>
  <div class="flex items-center justify-center text-center">
    <UTabs
      v-model:model-value="currentModel"
      :items="items"
      class="w-[62px] h-6 text-xs"
      :ui="{
        base: 'p-0',
        list: {
          height: 'h-7 !py-0',
          tab: {
            base: '!p-0',
            height: 'h-6',
            size: 'text-xs',
          },
        },
      }"
    >
      <template #default="{ item, selected }">
        <span
          class="truncate"
          :class="[selected && 'text-jc']"
          @click="changeLang(item)"
          >{{ item.label }}</span
        >
      </template>
    </UTabs>
  </div>
</template>

<script lang="ts" setup>
  import { isClient } from '@vueuse/core'

  const { locale, locales, setLocaleCookie, setLocale } = useI18n()
  const { setLanguage, closeHeaderPopup } = useMySystemStore()

  const currentModel = ref(0)
  const items = computed(() =>
    locales.value.map((item) => {
      return {
        label: locale.value === 'en-US' ? item.name : item.nameCn || '',
        code: item.code,
      }
    }),
  )
  async function changeLang(item: any) {
    setLocale(item.code)
    setLocaleCookie(item.code)
    setLanguage(item.code)
  }
  watch(
    locale,
    (newLocale) => {
      if (newLocale) {
        console.log('🍉 ~ LangSwitcher.vue:55 ~ newLocale:', newLocale)
        if (isClient) {
          const langPath = newLocale === 'en-US' ? 'en' : 'cn'
          currentModel.value = newLocale === 'en-US' ? 0 : 1
          const currentPath = window.location.pathname
          const currentQuery = window.location.search
          const newPath = currentPath.replace(/^\/(en|cn)\/?/, '/')
          const { hash } = window.location
          const newFullPath = `/${langPath}${newPath}`
          const queryParams = new URLSearchParams(currentQuery)

          if (hash) {
            navigateTo({
              path: `${newFullPath}${hash}`,
              query: Object.fromEntries(queryParams),
              replace: true,
            })
          } else {
            navigateTo({
              path: newFullPath,
              query: Object.fromEntries(queryParams),
              replace: true,
            })
          }
        }
      }
    },
    {
      immediate: true,
    },
  )
</script>

<style></style>
